import React, { PropTypes } from 'react'
import {
	Normal,
	Actualite,
	Dossier,
	Media,
	Presse,
	Statistique,
	FichePratique,
} from './teasers'

function PresseTeaser(props) {
	switch (props.apr_type) {
		case 'actualite':     return <Actualite {...props} />
		case 'statistique':   return <Statistique {...props} />
		case 'fichepratique': return <FichePratique {...props} />
		case 'presse':        return <Presse {...props} />
		case 'dossier':       return <Dossier {...props} />
		case 'media':         return <Media {...props} />
		default:              return React.createElement(props.defaultType, props)
	}
}

PresseTeaser.defaultProps = {
	defaultType: Actualite,
}

PresseTeaser.propTypes = {
	defaultType: PropTypes.oneOf([
		Normal,
		Actualite,
		Dossier,
		Media,
		Presse,
		Statistique,
		FichePratique,
	]).isRequired,
}

export {
	PresseTeaser,
	PresseTeaser as default,
}



// WEBPACK FOOTER //
// ./js/website/react_components/PresseTeaser.js